import { IUsageSummary } from "../interface/IUsageSummary";
import { Typography } from "@mui/material";
import { formatUsage } from "../usageUtils";
import { useTranslation } from "react-i18next";
import { centsToPrice } from "itsf-ui-common";

interface IParams {
    usageSummary: IUsageSummary;
}

export const CarouselItem = (props: IParams) => {
    const { usageSummary } = props;
    const { t } = useTranslation("usage");

    return (
        <div className="slide-content-border">
            <div className="slide-content">
                <Typography className="display-name" variant="small">
                    {usageSummary.usageTypeName}
                </Typography>
                <Typography color="primary" variant="h2">
                    {formatUsage(usageSummary)}
                </Typography>
                <Typography variant="small">{t("price", { price: centsToPrice(usageSummary.amount) })}</Typography>
            </div>
        </div>
    );
};
